import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import { createFormStoreEvents } from '../create-form-store-events';

export const consumptionsFormEvents = createFormStoreEvents('consumptionsStore');

export const consumptionsEvents = eventGroup({
  source: 'consumptionsStore',
  events: {
    clearFuelSpec: type<number>(),
  },
});
